import { css } from "@emotion/react";

export default {
  frame: css`
    border: none;
  `,
};
